type Category =
  | "DigiCGT - Compose - Open question category"
  | "DigiCGT - Compose - Close question category"
  | "DigiCGT - Compose - Toggle all questions on"
  | "DigiCGT - Compose - Toggle all questions off"
  | "DigiCGT - Compose - Show preview"
  | "DigiCGT - Start diary"
  | "DigiCGT - results - Open context drawer"
  | "DigiCGT - Add graph to report"
  | "DigiCGT - Create report"
  | "DigiCGT - Switched language";

// https://matomo.org/faq/reports/the-anatomy-of-an-event/
// Category (Required) – This describes the type of events you want to track. For example, Link Clicks, Videos, Outbound Links, and Form Events.
// Action (Required) – This is the specific action that is taken. For example, with the Video category, you might have a Play, Pause and Complete action.
// Name (Optional – Recommended) – This is usually the title of the element that is being interacted with, to aid with analysis. For example, it could be the name of a Video that was played or the specific form that is being submitted.
// Value (Optional) – This is a numeric value and is often added dynamically. It could be the cost of a product that is added to a cart, or the completion percentage of a video.
type TrackEventArgs = {
  category: Category;
  action?: string;
  name: string;
};

export const trackEvent = ({ category, action = "Clicked", name }: TrackEventArgs) => {
  // name and action are switched on purpose: name gives more information, so we
  // want to mention it first.
  window._paq?.push(["trackEvent", category, action, name]);
};

export const trackRouteChange = (pathname: string) => {
  if (window._paq) {
    window._paq.push(["setCustomUrl", pathname]);
    window._paq.push(["setDocumentTitle", "URL/Route change"]);
    window._paq.push(["trackPageView"]);
  }
};

export const trackPageView = (title: string) => {
  window._paq?.push(["trackPageView", title]);
};
